import { createEffect, createMemo, on, onMount } from "solid-js";
import { useWire } from "~/wire";

export const FeatureBaseSDKLink = `!(function(e,t){var a="featurebase-sdk";function n(){if(!t.getElementById(a)){var e=t.createElement("script");(e.id=a),(e.src="https://do.featurebase.app/js/sdk.js"),t.getElementsByTagName("script")[0].parentNode.insertBefore(e,t.getElementsByTagName("script")[0])}};"function"!=typeof e.Featurebase&&(e.Featurebase=function(){(e.Featurebase.q=e.Featurebase.q||[]).push(arguments)}),"complete"===t.readyState||"interactive"===t.readyState?n():t.addEventListener("DOMContentLoaded",n)})(window,document);`;

export const FeatureBaseMessengerInit = () => {
  onMount(() => {
    if ("Featurebase" in window && typeof window.Featurebase === "function") {
      window.Featurebase("boot", {
        appId: "6697ed83c44f55af67e1cf19",
        theme: "light",
        language: "en",
        email: wire.auth.user()?.primaryEmail ?? "",
        id: wire.auth.user()?.id,
        name: wire.auth.user()?.displayName ?? "",
      });
    }
  });

  const wire = useWire();
  const stableUserId = createMemo(() => wire.auth.user()?.id);

  createEffect(
    on(stableUserId, (id) => {
      if (id) {
        if ("Featurebase" in window && typeof window.Featurebase === "function") {
          window.Featurebase("identify", {
            email: wire.auth.user()?.primaryEmail ?? "",
            id,
            name: wire.auth.user()?.displayName ?? "",
            organization: "Storytell",
          });
          window.Featurebase("boot", {
            appId: "6697ed83c44f55af67e1cf19",
            theme: "light",
            language: "en",
            email: wire.auth.user()?.primaryEmail ?? "",
            id,
            name: wire.auth.user()?.displayName ?? "",
          });
        }
      }
    }),
  );
  return null;
};
